import { Link } from "@tanstack/react-router";
import { Breadcrumb } from "antd";

export interface Crumb {
	label: string;
	to?: string;
}

/**
 * "Ro'yxat → profil → tafsilot" burg'ulash naqshining navigatsion ustuni.
 *
 * `to` bo'lmagan bo'g'in oxirgi (joriy) bo'g'in sifatida qaraladi — u
 * havola emas, chunki foydalanuvchi allaqachon o'sha sahifada turibdi.
 * Dizayn kanvasidagi ko'rinish: 12px matn, ajratgich `#8a929e`, havola
 * `#1c5cab`, joriy bo'g'in `#14171c` (dark: `#e6e8eb`, `colorText`) va `font-weight: 500`.
 */
export function Breadcrumbs({ items }: { items: Crumb[] }) {
	return (
		<Breadcrumb
			className="text-xs"
			separator={<span className="text-[#8a929e]">/</span>}
			items={items.map((item, index) => ({
				key: `${item.label}-${index}`,
				title: item.to ? (
					<Link to={item.to} className="text-[#1c5cab] hover:underline dark:text-[#6fa3e6]">
						{item.label}
					</Link>
				) : (
					<span className="text-[#14171c] font-medium dark:text-[#e6e8eb]">{item.label}</span>
				),
			}))}
		/>
	);
}
